module.exports = "div.background-disabled {\n    background-color: #f3f3f3;\n}\n\ndiv.margin-vert-20 {\n    margin: 20px 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/postcodes/postcodes-detail/postcodes-detail.component.css
// module id = ./src/app/postcodes/postcodes-detail/postcodes-detail.component.css
// module chunks = main